// @flow
import React, {PureComponent} from 'react';
import {FlatList} from '../../../../components/common';
import RoamingFrame from './RoamingFrame.container';
import TravelFrame from './TravelFrame.container';
import type {PackageUsages} from '../../../../modules/Usage/selectors';

export default class RoamingFrames extends PureComponent<Props> {
  renderPack = ({item}: {item: PackageUsages}) => {
    const {type} = this.props;
    const props = {...item, type};
    return type === 'TRAVEL' ? (
      <TravelFrame {...props} />
    ) : (
      <RoamingFrame {...props} />
    );
  };

  keyExtractor = (pack: PackageUsages) => pack.zone;

  render() {
    return (
      <FlatList
        data={this.props.packages}
        renderItem={this.renderPack}
        keyExtractor={this.keyExtractor}
        scrollEnabled={false}
      />
    );
  }
}

type Props = {
  packages: ?(PackageUsages[]),
  type: 'ROAM_LIKE_HOME' | 'TRAVEL',
};

export type StateProps = {
  packages: ?(PackageUsages[]),
};
